import { get } from 'lodash-es';

import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

const RadioGroupField = ({
  field = {}, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldTouched } = {},
  options = [],
  onChange = field.onChange,
  row,
  radioGroupSx = {},
  label = ''
}) => {
  const error = get(touched, field.name) && get(errors, field.name);
  return (
    <>
      {label && <FormLabel component='legend'>{label}</FormLabel>}
      <RadioGroup
        name={field.name}
        value={field.value}
        onChange={onChange}
        onBlur={() => setFieldTouched(field.name, true)}
        row={row}
        sx={radioGroupSx}
        aria-describedby={error ? `${field.name}-helper-text` : undefined}
      >
        {options.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      {error && <FormHelperText id={`${field.name}-helper-text`}>{error}</FormHelperText>}
    </>
  );
};

export default RadioGroupField;
